import { ApiProperty } from "@nestjs/swagger";

export class CompanyIdDateRangeRequest {
    @ApiProperty()
    companyId: number;
    @ApiProperty()
    fromDate: string;
    @ApiProperty()
    toDate: string;

    /**
     * 
     * @param companyId 
     * @param fromDate 
     * @param toDate 
     */
    constructor(companyId: number, fromDate: string, toDate: string) {
        this.companyId = companyId;
        this.fromDate = fromDate;
        this.toDate = toDate;
    }
}